import ConnectionError from './ConnectionError'
import OutdatedError from './OutdatedError'
import CustomError from './CustomError'

export default {
  ConnectionError,
  OutdatedError,
  CustomError
}
